import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SearchBox from 'components/common/SearchBox';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { ChangeEvent, useEffect, useState } from 'react';
import { Button, Col, FloatingLabel, Form, Modal, Row } from 'react-bootstrap';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import AdvanceTable from 'components/base/AdvanceTable';
import { ColumnDef } from '@tanstack/react-table';
import { Link, useNavigate } from 'react-router-dom';
import { addService, deleteService, getService } from 'services/services';
import ConfirmationModal from 'components/modals/ConfirmationModal';
import {
  dateFormat,
  formatDateForAPI,
  validationErrorFromAPI
} from 'helpers/utils';
import { toast } from 'react-toastify';
import JsonToCsvButton from 'components/JsonToCsvButton';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import InvDropdownItems from 'components/common/InvDropdownItems';
import DatePicker from 'components/base/DatePicker';

interface Inventory {
  total_amt: any;
  gst_amt: any;
  stock: any;
  material: {
    name: string;
    current_stock: number;
  };
  id: number;
  batch_no: number;
  barcode: number;
  purchase_rate: number;
  maintan_date: string;
}
interface Fields {
  damage_date: string | Date;
  remark: string;
  damage_qty: string;
  inventory_id: string;
}

const InventoryViewList = () => {
  const navigate = useNavigate();
  const [inventoryList, setInventoryList] = useState([]);
  const [contractorId, setContractorId] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [materialList, setMaterialList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [stateId, setStateId] = useState('');
  const [materialId, setMaterialId] = useState('');
  const [inventoryId, setInventoryId] = useState('');
  const [materialName, setMaterialName] = useState('');
  const [show, setShow] = useState(false);

  const [fields, setFields] = useState<Fields>({
    inventory_id: '',
    damage_qty: '',
    damage_date: '',
    remark: ''
  });

  const handleShow = (data: any) => {
    setMaterialName(data.material.name);
    setShow(true);
    setInventoryId(data.id);
  };
  // const confirmAlert = (id: any) => {
  //   setShowAlert(true);
  //   setItemCodeId(id);
  // };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target; // Destructure the name and value from the event target
    setFields(prevFields => ({
      ...prevFields, // Spread the previous fields
      [name]: value // Update the specific field with the new value
    }));
  };

  const handleSave = async () => {
    fields.inventory_id = inventoryId;
    try {
      const response = await addService('master_inventory_damage', fields);

      if (response.status === 200) {
        toast.success('Added SuccessFully', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light'
        });
        setShow(false);
        fetch();
        setInventoryId('');
        setFields({
          inventory_id: '',
          damage_qty: '',
          remark: '',
          damage_date: ''
        });
      } else if (response?.status === 500) {
        validationErrorFromAPI(response.data);
      }
    } catch (error) {
      console.error('Error saving item:', error);
    }
  };

  const handleClose = () => {
    setShow(false);
    setInventoryId('');
    setFields({
      inventory_id: '',
      damage_qty: '',
      remark: '',
      damage_date: ''
    });
  };

  const fetchMaterial = async () => {
    const response = await getService('material');
    if (response.status === 200) {
      setMaterialList(response.data);
    }
  };

  const fetchState = async () => {
    const response = await getService('gstlist');
    if (response.status === 200) {
      setStateList(response.data);
    }
  };

  const handleStateChange = async (selectedStateId: string) => {
    if (selectedStateId) {
      setStateId(selectedStateId);
      const response = await getService(
        `master_inventory/${materialId ? materialId : 0}/${selectedStateId}`
      );
      if (response.status === 200) {
        setInventoryList(response.data);
      } else {
        setInventoryList(response.data);
      }
    } else {
      `master_inventory/${materialId ? materialId : 0}/${
        stateId ? stateId : 0
      }`;
    }
  };

  const handleMaterialChange = async (selectedMaterialId: string) => {
    if (selectedMaterialId) {
      setMaterialId(selectedMaterialId);
      const response = await getService(
        `master_inventory/${selectedMaterialId}/${stateId ? stateId : 0}`
      );
      if (response.status === 200) {
        setInventoryList(response.data);
      } else {
        setInventoryList(response.data);
      }
    } else {
      `master_inventory/${materialId ? materialId : 0}/${
        stateId ? stateId : 0
      }`;
    }
  };

  const filteredData = inventoryList.map((data: any) => ({
    invoice_no: data.invoice_no,
    barcode: data.barcode,
    batch_no: data.batch_no,
    material: data.material.name,
    unit_title: data.material.unitdata.unit_title,
    current_stock: data.material.current_stock,
    purchase_rate: data.purchase_rate,
    gst_amt: data.gst_amt,
    total_amt: data.total_amt
  }));

  const confirmAlert = (id: any) => {
    setShowAlert(true);
    setContractorId(id);
  };
  const removeApi = async () => {
    const response = await deleteService(`contractor/${contractorId}`);
    if (response?.status === 200) {
      toast.success('Remove SuccessFully', {
        position: 'top-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light'
      });
      fetch();
      setShowAlert(false);
      setContractorId('');
    } else if (response?.status === 500) {
      validationErrorFromAPI(response.data);
    }
  };
  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const membersTablecolumns: ColumnDef<Inventory>[] = [
    {
      accessorKey: 'material.name',
      header: 'Material Name',
      cell: ({ row: { original } }) => {
        const { name } = original.material;
        return (
          <Link to="#!" className="d-flex align-items-center text-body">
            <p className="mb-0 ms-3 text-body-emphasis fw-semibold">{name}</p>
          </Link>
        );
      },
      meta: {
        headerProps: {
          style: { width: '25%', minWidth: '200px' }, // Adjust width and minWidth as needed
          className: 'px-1'
        },
        cellProps: { className: 'align-middle white-space-nowrap py-2' }
      }
    },
    {
      accessorKey: 'batch_no',
      header: 'Batch No.',
      meta: {
        headerProps: {
          style: { width: '15%', minWidth: '200px' }
        },
        cellProps: { className: 'white-space-nowrap' }
      }
    },
    {
      accessorKey: 'barcode',
      header: 'Barcode No.',
      meta: {
        headerProps: {
          style: { width: '20%', minWidth: '200px' },
          className: 'pe-3'
        }
      }
    },
    {
      accessorKey: 'stock',
      header: 'Stock',
      cell: ({ row: { original } }) => {
        // Check if original.material exists and has current_stock property
        if (!original.material || original.stock === undefined) {
          return null;
        }

        const { stock } = original;

        return (
          <p className="mb-0 ms-3 text-body-emphasis fw-semibold">{stock}</p>
        );
      }
    },
    {
      accessorKey: 'purchase_rate',
      header: 'Purchase Rate',
      meta: {
        headerProps: {
          style: { width: '21%', minWidth: '200px' },
          className: 'text-end'
        },
        cellProps: {
          className: 'text-center text-body-tertiary'
        }
      }
    },
    {
      accessorKey: 'maintan_date',
      header: 'Expiry Date',
      cell: ({ row: { original } }) => {
        const { maintan_date } = original;
        return (
          <p className="mb-0 ms-3 text-body-emphasis fw-semibold">
            {dateFormat(maintan_date)}
          </p>
        );
      },
      meta: {
        headerProps: {
          style: { width: '21%', minWidth: '200px' },
          className: 'text-center'
        },
        cellProps: {
          className: 'text-center text-body-tertiary'
        }
      }
    },
    {
      accessorKey: 'lastActive',
      header: 'Amount without GST',
      cell: ({ row: { original } }) => {
        const { total_amt, gst_amt } = original;
        return (
          <p className="mb-0 ms-3 text-body-emphasis fw-semibold">
            {total_amt - gst_amt}
          </p>
        );
      },
      meta: {
        headerProps: {
          style: { width: '21%', minWidth: '200px' },
          className: 'text-center'
        },
        cellProps: {
          className: 'text-center text-body-tertiary'
        }
      }
    },
    {
      accessorKey: 'masterinvoice.sbu.state.name',
      header: 'STATE GST',
      meta: {
        headerProps: {
          style: { width: '21%', minWidth: '200px' },
          className: 'text-center'
        },
        cellProps: {
          className: 'text-center text-body-tertiary'
        }
      }
    },
    {
      id: 'action',
      cell: ({ row: { original } }) => {
        const { id } = original;
        return (
          <RevealDropdownTrigger>
            <RevealDropdown>
              <InvDropdownItems
                damageAction={() => handleShow(original)}
                // removeAction={() => confirmAlert(id)}
              />
            </RevealDropdown>
          </RevealDropdownTrigger>
        );
      },
      meta: {
        headerProps: { style: { width: '10%' }, className: 'text-end' },
        cellProps: { className: 'text-end' }
      }
    }
  ];

  const table = useAdvanceTable({
    data: inventoryList,
    columns: membersTablecolumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: true
  });

  useEffect(() => {
    fetch();
    fetchMaterial();
    fetchState();
  }, []);

  const fetch = async () => {
    const response = await getService(`master_inventory/${0}/${0}`);
    if (response.status === 200) {
      setInventoryList(response.data);
    } else if (response?.status === 500) {
      validationErrorFromAPI(response.data);
    }
  };

  return (
    <div>
      {showAlert && (
        <ConfirmationModal
          name={'Contractor'}
          show={showAlert}
          handleClose={() => setShowAlert(false)}
          handleAction={() => removeApi()}
        />
      )}
      <div className="mb-9">
        <h2 className="mb-5">Inventory</h2>

        <AdvanceTableProvider {...table}>
          <div className="mb-4">
            <Row className="g-3">
              <Col xs="auto">
                <SearchBox
                  placeholder="Search members"
                  onChange={handleSearchInputChange}
                />
              </Col>
              <Col xs="auto">
                <FloatingLabel controlId="floatingSelectTask" label="Material">
                  <Form.Select
                    name="Material Filter"
                    onChange={e => handleMaterialChange(e.target.value)}
                  >
                    <option value="0">Select Material</option>
                    {materialList.length > 0 &&
                      materialList.map((item: any) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs="auto">
                <FloatingLabel controlId="floatingSelectTask" label="State">
                  <Form.Select
                    name="Material Filter"
                    onChange={e => handleStateChange(e.target.value)}
                  >
                    <option value="0">Select State</option>
                    {stateList.length > 0 &&
                      stateList.map((item: any) => (
                        <option key={item.id} value={item.state_id}>
                          {item.state.name}
                        </option>
                      ))}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col
                xs="auto"
                className="scrollbar overflow-hidden-y flex-grow-1"
              ></Col>
              <Col xs="auto">
                {/* <Button variant="link" className="text-body me-4 px-0">
                  <FontAwesomeIcon icon={faFileExport} className="fs-9 me-2" />
                  Export
                </Button> */}
                <JsonToCsvButton
                  data={filteredData}
                  filename="Inventory Report.csv"
                />
                <Link className="btn btn-primary px-5" to="/CreateInventory">
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  Add Inventory
                </Link>
              </Col>
            </Row>
          </div>

          <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
            <MembersTable />
          </div>
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>{materialName} can be damaged?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col xs={12} xl={12}>
                  <Row as="form" className="g-3 mb-2">
                    <Col sm={6} md={6}>
                      <FloatingLabel
                        controlId="floatingInputGrid"
                        label="Damage Qty"
                      >
                        <Form.Control
                          type="number"
                          placeholder="Item Code"
                          name="damage_qty"
                          value={fields['damage_qty']}
                          onChange={handleChange}
                        />
                      </FloatingLabel>
                    </Col>
                    <Col sm={6} md={6}>
                      <DatePicker
                        value={fields['damage_date']}
                        options={{ enableTime: false, dateFormat: 'Y-m-d' }}
                        onChange={([date]) => {
                          setFields({
                            ...fields,
                            damage_date: formatDateForAPI(date)
                          });
                        }}
                        render={(_, ref) => {
                          return (
                            <Form.Floating>
                              <Form.Control
                                type="text"
                                placeholder="Project title"
                                ref={ref}
                                id="startDate"
                              />
                              <label htmlFor="startDate" className="ps-6">
                                Select damage date
                              </label>
                            </Form.Floating>
                          );
                        }}
                      />
                    </Col>
                    <Col xs={12}>
                      <FloatingLabel
                        controlId="floatingProjectOverview"
                        label="Write Damage Remark"
                      >
                        <Form.Control
                          as="textarea"
                          placeholder="Write Damage Remark"
                          name="remark"
                          value={fields['remark']}
                          onChange={handleChange}
                          style={{ height: '100px' }}
                        />
                      </FloatingLabel>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" onClick={handleSave}>
                Save Changes
              </Button>
            </Modal.Footer>
          </Modal>
        </AdvanceTableProvider>
      </div>
    </div>
  );
};

export const MembersTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
      <AdvanceTableFooter pagination />
    </div>
  );
};

export default InventoryViewList;
